import { Component, Vue } from "vue-property-decorator";
import { gps } from "@/config/host.config";
import axios from "@/api/AuthAPI/auth-request-api";

interface IGpsData {
  zoom: number;
  speed: number;
  latitude: number;
  longitude: number;
  course: number;
}

@Component({})
export default class GPSDotsModul extends Vue {
  latitude = 0;
  longitude = 0;

  async updateCoords(): Promise<void> {
    const gpsResponce = await axios.get(gps.mainAPI);
    if (gpsResponce.status === 200) {
      const data = gpsResponce.data as IGpsData;

      this.latitude = data.latitude;
      this.longitude = data.longitude;
    }
  }
}
